"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(trans, onlyProject, isBget) {
    if (onlyProject === void 0) { onlyProject = false; }
    if (isBget === void 0) { isBget = false; }
    var children = [
        {
            label: trans('project:slhh::labels.details'),
            identifier: 'project.project',
        },
        {
            label: trans('project:slhh::labels.home-visit'),
            identifier: 'project.home-visit',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.heating-system'),
            identifier: 'project.heating-system',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.hot-water'),
            identifier: 'project.hot-water',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.behavioural-advice'),
            identifier: 'project.behavioural-advice',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.warm-home'),
            identifier: 'project.warm-home',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.watersure'),
            identifier: 'project.watersure',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.white-goods'),
            identifier: 'project.white-goods',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.smart-meter'),
            identifier: 'project.smart-meter',
            enabled: !onlyProject,
        },
        isBget
            ? {
                label: trans('project:slhh::labels.bget'),
                identifier: 'project.bget',
                enabled: !onlyProject,
            }
            : false,
        {
            label: trans('project:slhh::labels.onward-referral'),
            identifier: 'project.onward-referral',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.feedback'),
            identifier: 'project.feedback',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.closings'),
            identifier: 'project.closings',
            enabled: !onlyProject,
        },
        {
            label: trans('project:slhh::labels.resident'),
            identifier: 'project.resident',
            enabled: !onlyProject,
        },
    ];
    return [
        {
            label: trans('project:slhh::labels.project-details'),
            children: children.filter(Boolean),
        },
    ];
}
exports.default = default_1;
//# sourceMappingURL=tabs.js.map